import { useCallback, useState } from "react";
import type { AlertColor, Theme } from "@mui/material";
import { Box, Link, Typography, styled, useMediaQuery } from "@mui/material";
import { useDoctorContext } from "../../../context";
import { Modal, SnackBar } from "../../../components";
import { shareDoctorLink } from "../../../utils";

const Container = styled(Box)({
  paddingTop: "24px",
});

const Text = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.primary,
}));

const StyledLink = styled(Link)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.link,
  cursor: "pointer",
  textDecoration: "underline",
}));

export function ShareLink() {
  const doctor = useDoctorContext();
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const [showCopiedLinkModal, setShowCopiedLinkModal] = useState(false);

  const [snackBarState, setSnackBarState] = useState({
    open: false,
    type: "success" as AlertColor,
  });

  const onShare = useCallback(async () => {
    await shareDoctorLink({
      doctorCode: doctor.code,
      setShowCopiedLinkModal,
      setSnackBarState,
      isDesktop,
    });
  }, [doctor.code, isDesktop]);

  return (
    <>
      <Container>
        <Text>
          Si quieres que el paciente complete sus datos{" "}
          <StyledLink onClick={onShare}>haz click aquí</StyledLink>
        </Text>
      </Container>
      <Modal
        title="Link copiado"
        content="Pégalo en WhatsApp o en un correo para enviarlo al paciente."
        isOpen={showCopiedLinkModal}
        onClose={() => setShowCopiedLinkModal(false)}
        buttonProps={{
          buttonText: "Aceptar",
          onClick: () => {
            setShowCopiedLinkModal(false);
          },
        }}
      />
      <SnackBar
        snackBarState={snackBarState}
        onClose={() => setSnackBarState({ ...snackBarState, open: false })}
        alerts={{
          success: "Link copiado, compártelo con tu paciente",
          error: "Ocurrió un error al copiar el link",
        }}
      />
    </>
  );
}
